import React from 'react';
import LocationTemplate from './LocationTemplate';

const MaysvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Maysville"
      stateName="North Carolina"
      countyName="Jones"
      zipCodes={["28555"]}
      latitude={34.9052}
      longitude={-77.2338}
      population={959}
      historicalFact="Established in 1890, developed as a turpentine and timber shipping point."
      nearbyTowns={[
        "Jacksonville, NC",
        "New Bern, NC",
        "Kinston, NC",
        "Trenton, NC",
        "Pollocksville, NC",
        "Richlands, NC",
        "Swansboro, NC",
        "Sneads Ferry, NC"
      ]}
    />
  );
};

export default MaysvillePage;